export default function SkeletonCard() {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden animate-pulse">
      <div className="h-1.5 w-full bg-gray-200" />
      <div className="p-5">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            <div className="h-5 bg-gray-200 rounded w-3/4 mb-2" />
            <div className="h-3 bg-gray-100 rounded w-1/3" />
          </div>
          <div className="h-7 w-10 bg-gray-200 rounded ml-3" />
        </div>
        <div className="flex gap-1 mb-3">
          {[1, 2, 3, 4, 5].map((s) => (
            <div key={s} className="h-3.5 w-3.5 bg-gray-200 rounded-full" />
          ))}
          <div className="h-3 w-8 bg-gray-100 rounded ml-1" />
        </div>
        <div className="space-y-2 mb-4">
          <div className="h-3 bg-gray-100 rounded w-full" />
          <div className="h-3 bg-gray-100 rounded w-5/6" />
          <div className="h-3 bg-gray-100 rounded w-4/6" />
        </div>
        <div className="flex gap-2 flex-wrap">
          {[1, 2, 3].map((d) => (
            <div key={d} className="h-5 w-20 bg-gray-100 rounded-full" />
          ))}
        </div>
      </div>
      <div className="bg-gray-50 border-t border-gray-100 p-4">
        <div className="h-3 bg-gray-200 rounded w-1/3 mb-3" />
        <div className="space-y-1">
          <div className="h-3 bg-gray-100 rounded w-full" />
          <div className="h-3 bg-gray-100 rounded w-4/5" />
        </div>
      </div>
      <div className="px-5 py-3 border-t border-gray-50 flex justify-between">
        <div className="h-5 w-20 bg-gray-100 rounded-full" />
        <div className="h-5 w-14 bg-gray-100 rounded" />
      </div>
    </div>
  );
}
